export const SOCIAL_NETWORK_FILTER_KEYS = [
    'facebook',
    'instagram',
    'linkedin',
    'googleMyBusiness',
] as const;

export type SocialNetworkFilterKey = (typeof SOCIAL_NETWORK_FILTER_KEYS)[number];

export function getActiveSocialNetworkFilters(
    searchNetwork: Readonly<Record<string, boolean>>,
): SocialNetworkFilterKey[] {
    return SOCIAL_NETWORK_FILTER_KEYS.filter(key => searchNetwork[key]);
}

function normalizePublicationSocialNetworks(social: unknown): readonly string[] {
    if (Array.isArray(social)) {
        return social.filter((network): network is string => typeof network === 'string');
    }

    if (typeof social === 'string' && social.trim() !== '') {
        return social.split(',').map(network => network.trim());
    }

    return [];
}

export function publicationMatchesSocialNetworks(
    publication: Readonly<{ social?: unknown }>,
    activeNetworks: readonly SocialNetworkFilterKey[],
): boolean {
    if (activeNetworks.length === 0) {
        return true;
    }

    const publicationNetworks = normalizePublicationSocialNetworks(publication.social);
    return activeNetworks.some(network => publicationNetworks.includes(network));
}
